import DM from './dataManager';

export default DM;
